import { AuthService } from '../../services/auth.service';
import { ClienteService } from '../../services/cliente.service';
import { ListadoMovimientos, SaldoViewModel } from '../../models/viewmodels/listadoMovimientos';
import { Router } from '@angular/router';
var AplicadaComponent = /** @class */ (function () {
    function AplicadaComponent(clienteService, router, authService) {
        var _this = this;
        this.clienteService = clienteService;
        this.router = router;
        this.authService = authService;
        this.pagina = 0;
        this.cantidadPorPagina = 20;
        this.listado = new ListadoMovimientos();
        this.saldo = new SaldoViewModel();
        this.paginas = 0;
        this.isLoading = true;
        this.alert = {
            tipo: "danger",
            titulo: "",
            mensaje: "",
            visible: false
        };
        this.listado.movimientos = new Array();
        this.cliente = this.clienteService.getCliente();
        if (!this.cliente) {
            if (this.authService.token && this.authService.roles.indexOf("administrador") == -1) {
                this.router.navigate(['clientes']);
            }
            else {
                this.router.navigate(['dashboard/clientes']);
            }
        }
        this.clienteService.clienteEmitter.subscribe(function (cliente) {
            _this.cliente = cliente;
            _this.obtenerMovimientos(0);
        });
    }
    AplicadaComponent.prototype.ngOnInit = function () {
        this.obtenerMovimientos();
    };
    AplicadaComponent.prototype.obtenerMovimientos = function (paginaActual) {
        var _this = this;
        if (this.cliente) {
            this.pagina = paginaActual == null ? 0 : paginaActual;
            this.spinner.isRunning = true;
            this.clienteService.obtenerSaldo(this.cliente.id).subscribe(function (result) {
                _this.saldo = result;
            });
            this.clienteService.obtenerAplicada(this.cliente.id, this.pagina, this.cantidadPorPagina).subscribe(function (result) {
                _this.spinner.isRunning = false;
                _this.listado = result;
                if (_this.listado && _this.listado.total > 0) {
                    _this.paginas = Math.floor((_this.listado.total + _this.cantidadPorPagina - 1) / _this.cantidadPorPagina);
                }
            });
        }
    };
    AplicadaComponent.prototype.anterior = function () {
        this.obtenerMovimientos(this.pagina - 1);
    };
    AplicadaComponent.prototype.siguiente = function () {
        this.obtenerMovimientos(this.pagina + 1);
    };
    AplicadaComponent.prototype.buscar = function () {
        this.obtenerMovimientos();
    };
    AplicadaComponent.prototype.obtenerComprobante = function (comprobante) {
        var _this = this;
        this.clienteService.obtenerComprobante(this.cliente.id, comprobante).subscribe(function (response) {
            var blob = response.blob();
            var fileURL = URL.createObjectURL(blob);
            window.open(fileURL);
        }, function (error) {
            _this.alert.visible = true;
            _this.alert.titulo = "Error";
            _this.alert.mensaje = "Se ha producido un error al descargar el comprobante " + comprobante + ". Por favor vuelva a intentarlo.";
        });
    };
    AplicadaComponent.prototype.historica = function () {
        if (this.authService.token && this.authService.roles.indexOf("administrador") == -1) {
            this.router.navigate(['/clientes/ctacte/historica']);
        }
        else {
            this.router.navigate(['/dashboard/clientes/ctacte/historica']);
        }
    };
    AplicadaComponent.prototype.paginate = function (event) {
        //event.first = Index of the first record
        //event.rows = Number of rows to display in new page
        //event.page = Index of the new page
        //event.pageCount = Total number of pages
        this.obtenerMovimientos(event.page);
    };
    AplicadaComponent.ctorParameters = function () { return [{ type: ClienteService }, { type: Router }, { type: AuthService }]; };
    return AplicadaComponent;
}());
export { AplicadaComponent };
//# sourceMappingURL=aplicada.component.js.map


// WEBPACK FOOTER //
// aplicada.component.js